import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  autocomplete: "off",
  class: "p-fluid"
}
const _hoisted_2 = { class: "p-field p-grid" }
const _hoisted_3 = {
  for: "customer_name",
  class: "p-col-12"
}
const _hoisted_4 = { class: "p-inputgroup" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" })
], -1)
const _hoisted_6 = { class: "p-field p-grid" }
const _hoisted_7 = {
  for: "phone",
  class: "p-col-12"
}
const _hoisted_8 = { class: "p-inputgroup" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone" })
], -1)
const _hoisted_10 = { class: "p-field p-grid" }
const _hoisted_11 = {
  for: "email",
  class: "p-col-12"
}
const _hoisted_12 = { class: "p-inputgroup" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" })
], -1)
const _hoisted_14 = { class: "p-field p-grid" }
const _hoisted_15 = {
  for: "address",
  class: "p-col-12"
}
const _hoisted_16 = { class: "p-inputgroup" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map-marker" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("customer.name")), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_InputText, {
          id: "customer_name",
          type: "text",
          "model-value": _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:name', $event))),
          class: _normalizeClass({ 'p-invalid': _ctx.error })
        }, null, 8, ["model-value", "class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("customer.phone")), 1),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_InputText, {
          id: "phone",
          type: "text",
          "model-value": _ctx.phone,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:phone', $event))),
          class: _normalizeClass({ 'p-invalid': _ctx.phoneError })
        }, null, 8, ["model-value", "class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("customer.email")), 1),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_InputText, {
          id: "email",
          type: "text",
          "model-value": _ctx.email,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:email', $event))),
          class: _normalizeClass({ 'p-invalid': _ctx.errorEmail })
        }, null, 8, ["model-value", "class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("customer.address")), 1),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_InputText, {
          id: "address",
          type: "text",
          "model-value": _ctx.address,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:address', $event)))
        }, null, 8, ["model-value"])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}